  import { BrowserRouter, Routes, Route } from 'react-router';
import ScrollToTop from './components/ScrollToTop.js';
//import { useEffect } from 'react';
import Home from './Home.js';
import Header from "./components/header/head.jsx";
import Footer from "./components/Footer.jsx";
import AboutUs from './pages/AboutUs.js';
import Testimonials from './pages/Testimonials.jsx';
//import MediaPage from './pages/Media.jsx';
import ContactUs from './pages/Contact.js';
import { projects } from './assets/projects.js';
import Properties from './projects/Properties.jsx';
import LocationPage from './projects/LocationPage.jsx';
import PropertyListing from './projects/SingleListing.jsx';

import WhatsappButton from './chat/WhatsappButton.js';
import TidioWidget from './chat/TidioWidget.js';


// Get unique locations
const locations = [...new Set(projects.map(product => product.location))];

const App = () => {
  return (
<>
    <BrowserRouter>
    <ScrollToTop />
     <Header locations={locations} />
     <Routes>
        
        <Route path='/' element = {<Home />}> </Route>
        {locations.map(location => (
          <Route 
            key={location}
            path={`/locations/:location`}
            element={<LocationPage />}
          />
        ))}

        <Route path = '/property/:productId' element = {<PropertyListing />}>
        </Route>

    <Route path = "/Properties" element = {<Properties/>}>        </Route>

    <Route path = "/AboutUs" element = {<AboutUs/>}>        </Route>

    {/*<Route path = "/Media" element = {<MediaPage/>}>        </Route>*/}

    <Route path = "/Contact" element = {<ContactUs/>}>        </Route>

    <Route path = "/Testimonials" element = {<Testimonials/>}>        </Route>

      </Routes>
      <WhatsappButton />
      <TidioWidget />
      {/*<Testimonial />*/}
      <Footer />
    </BrowserRouter>
    </>
  );
}


export default App;
